import React, { useEffect } from 'react';

const InstagramFeed = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up on unmount
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      className="elfsight-app-687aa463-0394-4bc7-a2d8-8599839d2670"
      data-elfsight-app-lazy
    ></div>
  );
};

export default InstagramFeed;
